import styled from "styled-components";

export const SectionReviews = styled.section`
    padding-bottom: 150px;
`;

export const ReviewsContainer = styled.div``;

export const ReviewsTitle = styled.h2`
    padding-left: 125px;

    font-weight: 700;
    font-size: 79px;
    margin-bottom: 74px;
    line-height: 1;
    position: relative;
    z-index: 1;
    @media (max-width: 1199px) {
        font-size: 60px;
        padding-left: 25px;
        margin-bottom: 64px;
    }
    @media (max-width: 599px) {
        font-size: 50px;
        padding-left: 25px;
        margin-bottom: 34px;
    }
`;
